import { GlobalAxios } from "../axios/axios-config";
import { ICalendarClassificationExam } from "../models/calendar-classification-exam";

const CALENDAR_CLASSIFICATION_EXAM_ROUTE =
  process.env.REACT_APP_EXTERNAL +
  "/api/v1/CalendarClassificationExam/CalendarClassificationExam";

export const calendarClassificationExamList = (params?: any) => {
  return GlobalAxios.get<ICalendarClassificationExam[]>(
    CALENDAR_CLASSIFICATION_EXAM_ROUTE,
    {
      params: params,
      paramsSerializer: { indexes: null },
    }
  );
};
